import { Resource } from '@domain/base/Resource';
import { Connector } from '@domain/connection/models/Connector';
import { Connection } from '@domain/connection/models/Connection';
import { ConnectionsDataSource } from '../datasources/MarketplaceDataSource';
import { ConnectionMapper } from '../mappers/MarketplaceMapper';
import { IConnectionsRepository } from '@domain/connection/IMarketplaceRepository';

export class ConnectionsRepository implements IConnectionsRepository {
  constructor(private dataSource: ConnectionsDataSource) { }

  async fetchConnectors(type?: string): Promise<Resource<Connector[]>> {
    try {
      const data = await this.dataSource.fetchConnectors(type);
      return {
        status: 'success',
        data: data.map(ConnectionMapper.toModel)
      };
    } catch (error) {
      return {
        status: 'error',
        error: {
          type: 'UnknownError',
          message: 'Failed to fetch marketplaces'
        }
      };
    }
  }

  async fetchConnections(): Promise<Resource<Connection[]>> {
    try {
      const data = await this.dataSource.fetchConnections();
      return {
        status: 'success',
        data: data.map(ConnectionMapper.toConnectionModel)
      };
    } catch (error) {
      return {
        status: 'error',
        error: {
          type: 'UnknownError',
          message: 'Failed to fetch marketplace connections'
        }
      };
    }
  }

  async removeConnection(connectionId: string): Promise<Resource<void>> {
    try {
      await this.dataSource.removeConnection(connectionId);
      return { status: 'success', data: undefined };
    } catch (error) {
      return {
        status: 'error',
        error: {
          type: 'UnknownError',
          message: 'Failed to remove marketplace connection'
        }
      };
    }
  }
}
